/*
 * Photos for the home page gallery, shown in this order.
 *
 * Each photo has two versions in public/gallery/:
 *   - "wide": 3000px wide, for desktops and landscape screens
 *   - "tall": a 1440×2400 crop around the subject, for phones held upright
 * position: where the subject is in the wide photo ("x% y%"), so it stays in
 *   view when the screen crops the photo.
 */
export const GALLERY = [
  {
    wide: "/gallery/photo1-wide.webp",
    tall: "/gallery/photo1-tall.webp",
    position: "60% 60%",
    alt: "thangcao standing by the water under a bridge",
  },
  {
    wide: "/gallery/photo2-wide.webp",
    tall: "/gallery/photo2-tall.webp",
    position: "70% 50%",
    alt: "thangcao from behind, looking out over the water",
  },
  {
    wide: "/gallery/photo8-wide.webp",
    tall: "/gallery/photo8-tall.webp",
    position: "52% 50%",
    alt: "thangcao from behind, holding a paper plane by the water",
  },
  {
    wide: "/gallery/photo4-wide.webp",
    tall: "/gallery/photo4-tall.webp",
    position: "68% 60%",
    alt: "thangcao standing in front of a wall of rocks",
  },
  {
    wide: "/gallery/photo5-wide.webp",
    tall: "/gallery/photo5-tall.webp",
    position: "70% 50%",
    alt: "thangcao half in shadow",
  },
  {
    wide: "/gallery/photo9-wide.webp",
    tall: "/gallery/photo9-tall.webp",
    position: "62% 40%",
    alt: "thangcao sitting on the rocks at night, holding a stone",
  },
  {
    wide: "/gallery/photo6-wide.webp",
    tall: "/gallery/photo6-tall.webp",
    position: "67% 65%",
    alt: "thangcao crouching on the rocks in a pool of light",
  },
];
